import { useOpenSearchKebabEvents } from 'hooks/events/useOpenSearchKebabEvents';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { TKebabMenuProps } from 'open-search/types';

export function useKebabMenu() {
  const { isMobile } = useDeviceSize();

  const { isKebabVisible, searchTruckerData, setIsKebabVisible } = useOpenSearchContext();

  const { sendOpenKebabEvents } = useOpenSearchKebabEvents();

  const handleOpenKebab = () => {
    sendOpenKebabEvents();
    setIsKebabVisible(true);
  };

  const handleCloseKebab = () => setIsKebabVisible(false);

  const propsKebabMenu: TKebabMenuProps = {
    inverted: searchTruckerData?.trucker?.isVip,
    isMobile,
    isKebabVisible,
    onClick: () => handleOpenKebab(),
    onClose: () => handleCloseKebab(),
  };

  return { propsKebabMenu };
}
